import { render, staticRenderFns } from "./CounselLogin.vue?vue&type=template&id=29285159&scoped=true&"
import script from "./CounselLogin.vue?vue&type=script&lang=js&"
export * from "./CounselLogin.vue?vue&type=script&lang=js&"
import style0 from "./CounselLogin.vue?vue&type=style&index=0&id=29285159&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29285159",
  null
  
)

export default component.exports